import Error from "../pages/error";
import Currency from "../pages/sb/currency/currencyIndex";
import CurrencyShow from "../pages/sb/currency/currencyShow";
import CurrencyStore from "../pages/sb/currency/currencyStore";
import SystemSettings from "../pages/system settings";
import CountriesShow from "../pages/sb/countries/countriesShow";
import CountriesStore from "../pages/sb/countries/countriesStore";
import CitesShow from "../pages/sb/cites/citesShow";
import CitesStore from "../pages/sb/cites/citesStore";
import NationalitesShow from "../pages/sb/nationalities/nationalitesShow";
import NationalitiesStore from "../pages/sb/nationalities/nationalitiesStore";
import RequestsShow from "../pages/sb/requests/requestsShow";
import RequestsStore from "../pages/sb/requests/requestsStore";
import CompanyShow from "../pages/sb/companyFields/companyFieldsShow";
import CompanyFieldsStore from "../pages/sb/companyFields/companyFieldesStore";
import CompanySettings from "../pages/companySettings";
import LevelsShow from "../pages/hr/levels/levelsShow";
import LevelsStore from "../pages/hr/levels/levelsStore";
import EmpolymentShow from "../pages/hr/empolymentTypes/empolymentShow";
import EmpolyMentTypesStore from "../pages/hr/empolymentTypes/empolymentStore";
import BranchesShow from "../pages/sb/Branches/branchesShow";
import BranchesStore from "../pages/sb/Branches/branchesStore";
import ShiftsShow from "../pages/sb/shifts/shiftsShow";
import ShiftsStore from "../pages/sb/shifts/shiftsStore";
import CompaniesShow from "../pages/sb/companies/companiesShow";
import CompaniesStore from "../pages/sb/companies/companiesStore";
import DepartmentsShow from "../pages/sb/departments/departmentsShow";
import DevicesShow from "../pages/sb/device/deviceShow";
import DevicesStore from "../pages/sb/device/deviceStore";
import RulesStore from "../pages/sb/rules/rulesStore";
import EmployesShow from "../pages/sb/employes/employesShow";
import EmployesStore from "../pages/sb/employes/employesStore";
import DesignationStore from "../pages/hr/designations/designationsStore";
import DesignationsShow from "../pages/hr/designations/designationsShow";
import AttendanceShow from "../pages/hr/attendance/attendanceShow";
import SalaryShow from "../pages/hr/salary/salaryShow";
import SalaryStore from "../pages/hr/salary/salaryStore";
import AttendanceStore from "../pages/hr/attendance/attendanceStore";
import ConstractsStore from "../pages/hr/constracts/constractsStore";
import PayrollsStore from "../pages/hr/payrolls/payrollsStore";
import Map from "../pages/map";
import ConstractsShow from "../pages/hr/constracts/constractsShow";
import PayrollsShow from "../pages/hr/payrolls/payrollsShow";
import DepartmentStore from "../pages/sb/departments/departmentsStore";
import TaskShow from "../pages/crm/tasks/tasksShow";
import TasksStore from "../pages/crm/tasks/tasksStore";
import CompaniesUpdate from "../pages/sb/companies/companiesUpdate";
import DepartmentUpdate from "../pages/sb/departments/departmentsUpdate";
import EmployesUpdate from "../pages/sb/employes/employesUpdate";
import DevicesUpdate from "../pages/sb/device/deviceUpdate";
import Attendance from "../pages/hr/attendance/attendanceIndex";
import Branches from "../pages/sb/Branches/branchesIndex";
import Tasks from "../pages/crm/tasks/tasksindex";
import SalariesSettings from "../pages/salariesSettings";
import Profile from "../pages/core/profile";
import CompanyInformation from "../pages/core/CompanyInfo";
import Departments from "../pages/sb/departments/departmentsIndex";
import Employes from "../pages/sb/employes/employesIndex";
import Constracts from "../pages/hr/constracts/constractsIndex";
import Salary from "../pages/hr/salary/salaryIndex";
import Requests from "../pages/sb/requests/requestsIndex";
import EmployRequests from "../pages/hr/employeRequests/employRequestsIndex";
import EmployeRequestsStore from "../pages/hr/employeRequests/employRequestsStore";
import EmployeRequestShow from "../pages/hr/employeRequests/employRequestsShow";
import Home from "../pages/home";
import CompanyRulesShow from "../pages/sb/companyRules/companyRulesShow";
import CompanyRulesStore from "../pages/sb/companyRules/companyRulesStore";
import CategoriesStore from "../pages/sb/categories/categoriesStore";
import ArticlesStore from "../pages/sb/articles/articlesStore";
import PagesStore from "../pages/sb/pages/pagesStore";
import CompanyRulesUpdate from "../pages/sb/companyRules/companyRulesUpdate";
import ArticlesShow from "../pages/sb/articles/articlesShow";
import ShiftsUpdate from "../pages/sb/shifts/shiftsUpdate";
import RulesShow from "../pages/sb/rules/rulesShow";
import ConstractsUpdate from "../pages/hr/constracts/constractsUpdate";
import SalaryUpdate from "../pages/hr/salary/salaryUpdate";
import LevelsUpdate from "../pages/hr/levels/levelsUpdate";
import EmployeRequestsUpdate from "../pages/hr/employeRequests/employRequestsUpdate";
import EmpolyMentTypesUpdate from "../pages/hr/empolymentTypes/empolymentUpdate";
import Payrolls from "../pages/hr/payrolls/payrollsIndex";
import EmployeAttachmentsStore from "../pages/sb/employes/employesStore/employeAttachmentsStore";
import EmployeAttachmentupdate from "../pages/sb/employes/employesUpdate/employeattachmentupdate";
import PagesUpdate from "../pages/sb/pages/pagesUpdate";
import ArticlesUpdate from "../pages/sb/articles/articlesUpdate";
import CategoriesUpdate from "../pages/sb/categories/categoriesUpdate";
import PagesShow from "../pages/sb/pages/pagesShow";
import DesignationUpdate from "../pages/hr/designations/designationsupdate";
import BranchesUpdate from "../pages/sb/Branches/branchesUpdate";
import RequestsUpdate from "../pages/sb/requests/requestsUpdate";
import Settings from "../pages/sb/settings";
import Visits from "../pages/sb/visits";
import Bouns from "../pages/hr/bouns/bounsIndex";
import Deductions from "../pages/hr/deductions/deductionsIndex";
import DeductionsStore from "../pages/hr/deductions/deductionsStore";
import BounsStore from "../pages/hr/bouns/bounsStore";
import CategoriesShow from "../pages/sb/categories/categoriesShow";
import Holidays from "../pages/sb/holidays/holidaysIndex";
import HolidaysStore from "../pages/sb/holidays/holidaysStore";

export const routes = [
  { path: `${process.env.PUBLIC_URL}/home`, Component: <Home /> },
  {
    path: `${process.env.PUBLIC_URL}/systemsettings/currencies`,
    Component: <Currency />,
  },
  {
    path: `${process.env.PUBLIC_URL}/currencies/:id`,
    Component: <CurrencyShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/countries/:id`,
    Component: <CountriesShow />,
  },
  { path: `${process.env.PUBLIC_URL}/cites/:id`, Component: <CitesShow /> },
  {
    path: `${process.env.PUBLIC_URL}/nationalities/:id`,
    Component: <NationalitesShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/requests/:id`,
    Component: <RequestsShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companyfields/:id`,
    Component: <CompanyShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/empolymenttypes/:id`,
    Component: <EmpolymentShow />,
  },
  { path: `${process.env.PUBLIC_URL}/levels/:id`, Component: <LevelsShow /> },
  { path: `${process.env.PUBLIC_URL}/shifts/:id`, Component: <ShiftsShow /> },
  {
    path: `${process.env.PUBLIC_URL}/branches/:id`,
    Component: <BranchesShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companies/:id`,
    Component: <CompaniesShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/departments/:id`,
    Component: <DepartmentsShow />,
  },
  { path: `${process.env.PUBLIC_URL}/device/:id`, Component: <DevicesShow /> },
  { path: `${process.env.PUBLIC_URL}/employ/:id`, Component: <EmployesShow /> },
  { path: `${process.env.PUBLIC_URL}/salary/:id`, Component: <SalaryShow /> },
  {
    path: `${process.env.PUBLIC_URL}/payrolls/:month`,
    Component: <PayrollsShow />,
  },
  { path: `${process.env.PUBLIC_URL}/payrolls`, Component: <Payrolls /> },
  {
    path: `${process.env.PUBLIC_URL}/contracts/:id`,
    Component: <ConstractsShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/designation/:id`,
    Component: <DesignationsShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/attendances/:id`,
    Component: <AttendanceShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/devicestore`,
    Component: <DevicesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/salarystore`, Component: <SalaryStore /> },
  {
    path: `${process.env.PUBLIC_URL}/attendancestore`,
    Component: <AttendanceStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employesstore`,
    Component: <EmployesStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/designationsstore`,
    Component: <DesignationStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/designationsupdate/:id`,
    Component: <DesignationUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/branchesupdate/:id`,
    Component: <BranchesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/nationalitiesstore`,
    Component: <NationalitiesStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/empolementtypesstore`,
    Component: <EmpolyMentTypesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/levelsstore`, Component: <LevelsStore /> },
  {
    path: `${process.env.PUBLIC_URL}/constractsstore`,
    Component: <ConstractsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payrollsstore`,
    Component: <PayrollsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employeattachmentsstore/:id`,
    Component: <EmployeAttachmentsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/updateattachments/:id`,
    Component: <EmployeAttachmentupdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/currencystore`,
    Component: <CurrencyStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/holidaysstore`,
    Component: <HolidaysStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/countriesstore`,
    Component: <CountriesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/bouns`, Component: <Bouns /> },
  { path: `${process.env.PUBLIC_URL}/deductions`, Component: <Deductions /> },
  {
    path: `${process.env.PUBLIC_URL}/deductionsstore`,
    Component: <DeductionsStore />,
  },
  { path: `${process.env.PUBLIC_URL}/bounsstore`, Component: <BounsStore /> },
  { path: `${process.env.PUBLIC_URL}/rulesstore`, Component: <RulesStore /> },
  {
    path: `${process.env.PUBLIC_URL}/companiesstore`,
    Component: <CompaniesStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/categoriesstore`,
    Component: <CategoriesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/citesstore`, Component: <CitesStore /> },
  {
    path: `${process.env.PUBLIC_URL}/requestsstore`,
    Component: <RequestsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/departmentstore`,
    Component: <DepartmentStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/articlesstore`,
    Component: <ArticlesStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/articles/:id`,
    Component: <ArticlesShow />,
  },
  { path: `${process.env.PUBLIC_URL}/pagesstore`, Component: <PagesStore /> },
  {
    path: `${process.env.PUBLIC_URL}/pagesupdate/:id`,
    Component: <PagesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/articlesupdate/:id`,
    Component: <ArticlesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/categoriesupdate/:id`,
    Component: <CategoriesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companyrulesupdate/:id`,
    Component: <CompanyRulesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employmentrequestsupdate/:id`,
    Component: <EmployeRequestsUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employmenttypesupdate/:id`,
    Component: <EmpolyMentTypesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/salaryupdate/:id`,
    Component: <SalaryUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/levelupdate/:id`,
    Component: <LevelsUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/contractsupdate/:id`,
    Component: <ConstractsUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/branchesstore`,
    Component: <BranchesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/shiftsstore`, Component: <ShiftsStore /> },
  { path: `${process.env.PUBLIC_URL}/pages/:id`, Component: <PagesShow /> },
  {
    path: `${process.env.PUBLIC_URL}/companyfieldsstore`,
    Component: <CompanyFieldsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companysettings`,
    Component: <CompanySettings />,
  },
  {
    path: `${process.env.PUBLIC_URL}/systemsettings`,
    Component: <SystemSettings />,
  },
  { path: `${process.env.PUBLIC_URL}/employes`, Component: <Employes /> },
  { path: `${process.env.PUBLIC_URL}/contracts`, Component: <Constracts /> },
  { path: `${process.env.PUBLIC_URL}/salaries`, Component: <Salary /> },
  { path: `${process.env.PUBLIC_URL}/requests`, Component: <Requests /> },
  {
    path: `${process.env.PUBLIC_URL}/requestsupdate/:id`,
    Component: <RequestsUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employerequests`,
    Component: <EmployRequests />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employerequestsstore`,
    Component: <EmployeRequestsStore />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employerequests/:id`,
    Component: <EmployeRequestShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companyrules/:id`,
    Component: <CompanyRulesShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/companyrulesstore`,
    Component: <CompanyRulesStore />,
  },
  { path: `${process.env.PUBLIC_URL}/departments`, Component: <Departments /> },
  { path: `${process.env.PUBLIC_URL}/settings`, Component: <Settings /> },
  { path: `${process.env.PUBLIC_URL}/visits`, Component: <Visits /> },
  { path: `${process.env.PUBLIC_URL}/tasks/:id`, Component: <TaskShow /> },
  { path: `${process.env.PUBLIC_URL}/rules/:id`, Component: <RulesShow /> },
  { path: `${process.env.PUBLIC_URL}/tasksstore`, Component: <TasksStore /> },
  {
    path: `${process.env.PUBLIC_URL}/companyupdate/:id`,
    Component: <CompaniesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/departmentupdate/:id`,
    Component: <DepartmentUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employesupdate/:id`,
    Component: <EmployesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/devicesupdate/:id`,
    Component: <DevicesUpdate />,
  },
  {
    path: `${process.env.PUBLIC_URL}/shiftsupdate/:id`,
    Component: <ShiftsUpdate />,
  },
  { path: `${process.env.PUBLIC_URL}/attendance`, Component: <Attendance /> },
  { path: `${process.env.PUBLIC_URL}/branches`, Component: <Branches /> },
  { path: `${process.env.PUBLIC_URL}/tasks`, Component: <Tasks /> },
  { path: `${process.env.PUBLIC_URL}/holidays`, Component: <Holidays /> },
  {
    path: `${process.env.PUBLIC_URL}/category/:id`,
    Component: <CategoriesShow />,
  },
  {
    path: `${process.env.PUBLIC_URL}/salariesSettings`,
    Component: <SalariesSettings />,
  },
  { path: `${process.env.PUBLIC_URL}/user`, Component: <Profile /> },
  { path: `${process.env.PUBLIC_URL}/map`, Component: <Map /> },
  {
    path: `${process.env.PUBLIC_URL}/companyinformation/:id`,
    Component: <CompanyInformation />,
  },
  { path: "*", Component: <Error /> },
];
